import React from "react";
import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import {
  IdNameModel,
} from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";

type SelectQualificationTypeProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectQualificationType = ({
  ...props
}: SelectQualificationTypeProps) => {
  const { formatMessage: t } = useIntl();
  const { qualificationService } = useGlobalContext();

  const qualificationTypes = useQuery("qualificationTypes", () =>
    qualificationService.getQualificationTypes()
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={qualificationTypes}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectQualificationType;
